export enum FolderKind {
    FLOW = 0,
    LAYER = 1,
    ASSET = 2,
    ROUTE = 3
}
